import HotelStatusIcon from 'components/HotelStatusIcon'
import { useState } from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'

import { Cell, Row } from '../../../../components/ReusableComponents/Table'
import { formatPrice } from '../../../../utils/common'
import HotelIdCell from '../../Common/HotelIdCell'
import HotelNameCell from '../../Common/HotelNameCell'
import layoutStyles from '../Billing.module.scss'
import InvoiceFollowUpDialog from '../InvoiceFollowUpDialog'
import InvoiceMemoCell from '../InvoiceMemoCell'
import InvoicePromiseToPayCell from '../InvoicePromiseToPayCell'
import useInvoiceFollowUpNote from '../useInvoiceFollowUpNote'
import styles from './PMSBErow.module.scss'

const balanceStateLabels = {
  Paid: 'Paid',
  PaidPartially: 'Partial paid',
  PaymentPending: 'Payment pending',
  ReviewPending: 'Planned',
  ReviewCompleted: 'Planned',
  PaymentFailed: 'Payment failed',
  PaymentOverdue: 'Payment overdue',
  MonthInProgress: 'Month in progress',
  MonthSkipped: 'Month skipped',
  Unknown: 'Unknown'
}

const GoToBillingAndPayments = ({ subsidiaryId }) => {
  return (
    <Link to={`/s/${subsidiaryId}/billing`}>
      <button>Go to Billing &amp; Payments →</button>
    </Link>
  )
}

const BillingRow = ({
  displayId,
  brand,
  shortName,
  subsidiaryId,
  subsidiaryInvoiceId,
  index,
  subsidiaryStatus,
  rowStatus,
  statusExplanation,
  csmUserFullName,
  balanceState,
  invoiceDate,
  dueDate,
  agingDays,
  defaultPaymentMethod,
  totalAmountDue,
  balanceRemaining,
  invoiceBeginDate,
  invoiceEndDate,
  serviceBlockOn,
  promiseToPayDate,
  lastFollowUpNote,
  followUpNoteCount
}) => {
  const invoiceLabel = `${moment(invoiceBeginDate).format('MMM DD')} - ${moment(invoiceEndDate).format('MMM DD, YYYY')}`
  const [isFollowUpOpen, setIsFollowUpOpen] = useState(false)
  const { entries, isLoading, isSaving, error, hasLoaded, loadEntries, addEntry } =
    useInvoiceFollowUpNote(subsidiaryId, subsidiaryInvoiceId)

  const noteCount = hasLoaded
    ? entries.length
    : followUpNoteCount || (lastFollowUpNote ? 1 : 0)

  const rowStatusClass =
    rowStatus === 'alert'
      ? layoutStyles.billingRowStatusAlert
      : rowStatus === 'warning'
        ? layoutStyles.billingRowStatusWarning
        : rowStatus === 'green'
          ? layoutStyles.billingRowStatusGreen
          : ''

  return (
    <div
      className={`${layoutStyles.billingRowWrapper} ${rowStatusClass}`}
      title={statusExplanation}
    >
      <Row className={layoutStyles.billingGridRowBody}>
        <Cell className={styles.statusCell}>
          <HotelStatusIcon status={subsidiaryStatus} />
        </Cell>
        <Cell className={styles.indexCell}>{index}</Cell>
        <HotelIdCell displayId={displayId} />
        <HotelNameCell
          className={layoutStyles.billingStackedCell}
          brand={brand}
          name={shortName}
          navigationControl={<GoToBillingAndPayments subsidiaryId={subsidiaryId} />}
          serviceBlockOn={serviceBlockOn}
        />
        <Cell className={styles.textCell}>
          <span title={csmUserFullName}>
            {csmUserFullName
              ?.split(' ')
              .map(str => str[0])
              .join('.')}
          </span>
        </Cell>
        <Cell className={`${styles.textCell} ${styles.invoiceCell} ${layoutStyles.billingStackedCell}`}>
          <span className={styles.invoiceId}>#{subsidiaryInvoiceId}</span>
          <span className={styles.invoicePeriod}>{invoiceLabel}</span>
        </Cell>
        <Cell className={styles.textCell}>
          {balanceStateLabels[balanceState] || balanceState}
        </Cell>
        <Cell className={styles.textCell}>
          {invoiceDate ? moment(invoiceDate).format('MMM DD, YYYY') : '-'}
        </Cell>
        <Cell className={styles.textCell}>{moment(dueDate).format('MMM DD, YYYY')}</Cell>
        <Cell className={styles.textCell}>
          <span className={agingDays > 0 ? styles.overdueAging : styles.futureAging}>
            {agingDays}
          </span>
        </Cell>
        <Cell className={styles.textCell}>{defaultPaymentMethod || '-'}</Cell>
        <Cell className={styles.textCell}>{formatPrice(totalAmountDue)}</Cell>
        <Cell className={styles.textCell}>{formatPrice(balanceRemaining)}</Cell>
        <InvoicePromiseToPayCell
          subsidiaryId={subsidiaryId}
          subsidiaryInvoiceId={subsidiaryInvoiceId}
          promiseToPayDate={promiseToPayDate}
        />
        <InvoiceMemoCell
          noteCount={noteCount}
          onOpen={() => setIsFollowUpOpen(true)}
        />
      </Row>
      <InvoiceFollowUpDialog
        isOpen={isFollowUpOpen}
        onClose={() => setIsFollowUpOpen(false)}
        subsidiaryInvoiceId={subsidiaryInvoiceId}
        displayId={displayId}
        hotelName={`${brand ? `${brand}-` : ''}${shortName}`}
        totalAmountDue={totalAmountDue}
        balanceRemaining={balanceRemaining}
        balanceState={balanceStateLabels[balanceState] || balanceState}
        dueDate={dueDate}
        agingDays={agingDays}
        entries={entries}
        isLoading={isLoading}
        isSaving={isSaving}
        error={error}
        loadEntries={loadEntries}
        addEntry={addEntry}
      />
    </div>
  )
}

export default BillingRow
